/* eslint-disable @typescript-eslint/no-non-null-assertion */
import moment from "moment";
import { Dispatch, SetStateAction } from "react";

import { MapOpenLayerGisFileProps } from "../models";

export const createColorLegend = (
  gisFile: MapOpenLayerGisFileProps,
  color1Text: string | null,
  color2Text: string | null,
  color1: string,
  color2: string,
  midColour: string,
  minValue: number,
  maxValue: number
): HTMLDivElement => {
  const legend = document.createElement("div");

  // const middleColorText = "";
  // if (middleColor) {
  //   legend.innerHTML = `
  //   <div class="scale">
  //     <div class="scale-bar" style="background: linear-gradient(to right, ${color1}, ${middleColor}, ${color2})"></div>
  //     <div class="scale-labels">
  //       <span>${color1Text || minValue}</span>
  //       <span>${middleColorText || (minValue + maxValue) / 2}</span>
  //       <span>${color2Text || maxValue}</span>
  //     </div>
  //   </div>
  // `;
  // } else {
  if (gisFile.rasterLayer && gisFile.rasterLayer.rasterFillColours.length <= 3) {
    legend.className = "color-legend";
    legend.innerHTML = `
      <div class="scale">
        <div class="scale-bar" style="background: linear-gradient(to right, ${color1}, ${midColour ? `${midColour}` : `${color2}`}, ${color2})"></div>
        <div class="scale-labels">
          <span>${color1Text || minValue}</span>
          <span>${color2Text || maxValue}</span>
        </div>
      </div>
    `;
  } else {
    legend.className = "legend-container";
    gisFile?.rasterLayer?.rasterFillColours.forEach((item) => {
      legend.innerHTML += `
        <div class="legend-item">
          <div class="legend-color" style="background-color:${item.Colour}"></div>
          <div class="legend-text">${item.Text}</div>
        </div>`;
    });
  }
  // }
  return legend;
};

export const createDateSelector = (
  gisFile: MapOpenLayerGisFileProps,
  mapDateStr: string,
  setMapDateStr: Dispatch<SetStateAction<string>>
): HTMLDivElement => {
  const beginDate = moment(20230101, "YYYYMMDD");
  const endDate = moment(20241231, "YYYYMMDD");

  const dateOptions = gisFile.rasterLayer!.rasterFiles.map((x) => x.date);
  const sliderPositions = dateOptions!.map(
    (date) => (moment(date, "YYYYMMDD").diff(beginDate, "days") / endDate.diff(beginDate, "days")) * 100
  );
  const currentMapStr = gisFile?.rasterLayer!.rasterFiles.some((x) => x.date === mapDateStr)
    ? mapDateStr
    : gisFile.rasterLayer!.rasterFiles[0].date;

  const formattedDate = `${currentMapStr.slice(6, 8)}/${currentMapStr.slice(4, 6)}/${currentMapStr.slice(0, 4)}`;
  const inputValue =
    (moment(currentMapStr, "YYYYMMDD").diff(beginDate, "days") / endDate.diff(beginDate, "days")) * 100;
  const dateSelector = document.createElement("div");
  dateSelector.className = "date-selector";
  dateSelector.innerHTML = `
      <div class="date-range">
      <span>2023</span>
      <input
        type="range"
        id="date-filter"
        value=${inputValue}
        min=0
        max=100
      />
      <span>2025</span>
      </div>
      <div class="date-display">
      <span id="selected-date">${formattedDate}</span>
      </div>
  `;
  // Add the React event handler
  const input = dateSelector.querySelector("input");
  if (input) {
    input.addEventListener("input", () => {
      const closestIndex = sliderPositions.reduce(
        (prev, curr, index) =>
          Math.abs(curr - Number(input.value)) < Math.abs(sliderPositions[prev] - Number(input.value)) ? index : prev,
        0
      );
      input.value = sliderPositions[closestIndex].toString(); // Snap to closest tick
      setMapDateStr(dateOptions[closestIndex]);
    });
  }
  return dateSelector;
};

export const createMapInfoBox = (mapContextHead: string | null, mapContextContent: string | null): HTMLDivElement => {
  const mapContextDiv = document.createElement("div");
  mapContextDiv.className = "map-context-container";
  mapContextDiv.innerHTML = `
      <div class="message-title">${mapContextHead}</div>
      <div class="message-content">${mapContextContent}</div>
  `;
  return mapContextDiv;
};
